<template>
  <Card class="layout-card" style="height: 100%">
    <div class="header-container">
      <div class="search-form">
        <Input
          v-model="searchForm.userId"
          placeholder="用户UID"
          clearable
          style="width: 150px"
        />
        <Select
          v-model="searchForm.triggerTiming"
          placeholder="推送场景"
          clearable
          style="width: 200px"
        >
          <Option
            v-for="(item, index) in pushSceneOptions"
            :key="index"
            :value="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Input
          v-model="searchForm.popupName"
          placeholder="弹窗备注"
          clearable
          style="width: 200px"
        />
        <Button type="primary" @click="getData(1)">搜索</Button>
      </div>
      <div>
        <Button type="success" icon="md-add" @click="handleOpenAddModal"
          >新增弹窗测试</Button
        >
      </div>
    </div>

    <div class="table-container">
      <Table :data="tableData" :columns="columns" :loading="tableLoading">
        <template #triggerTiming="{ row }">
          {{ getPushSceneLabel(row.triggerTiming) }}
        </template>
        <template #action="{ row }">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="handleEdit(row)"
            >编辑</Button
          >
          <Button type="error" size="small" @click="handleDelete(row)"
            >删除</Button
          >
        </template>
        <template #footer>
          <Pages :page="page" :func="getData"></Pages>
        </template>
      </Table>
    </div>

    <!-- 新增/编辑弹窗测试 Modal -->
    <Modal
      v-model="addModalVisible"
      :title="addForm.id ? '编辑弹窗测试' : '新增弹窗测试'"
      @on-cancel="handleCancelAdd"
      :mask-closable="false"
      width="500"
    >
      <Form
        v-if="addModalVisible"
        :model="addForm"
        :label-width="120"
        ref="addFormRef"
      >
        <FormItem
          label="弹窗备注名称"
          prop="popupId"
          :rules="[
            {
              required: true,
              trigger: 'change',
              validator(rule, value, callback) {
                if (!value) {
                  callback('请选择弹窗')
                } else {
                  callback()
                }
              }
            }
          ]"
        >
          <Select
            v-model="addForm.popupId"
            filterable
            remote
            :remote-method="handleSearchPopup"
            :loading="popupSearchLoading"
            placeholder="请输入关键词搜索弹窗配置"
            clearable
          >
            <Option
              v-for="item in popupOptions"
              :key="item.id"
              :value="item.id"
              :label="item.popupName"
            >
            </Option>
          </Select>
        </FormItem>

        <FormItem
          label="推送用户UID"
          prop="userIds"
          :rules="[
            { required: true, message: '请输入用户UID', trigger: 'blur' }
          ]"
        >
          <Input
            v-model="addForm.userIds"
            type="textarea"
            :rows="3"
            placeholder="请输入用户UID，多个UID用英文逗号分隔"
          />
        </FormItem>

        <FormItem
          label="选择推送场景"
          prop="triggerTiming"
          :rules="[
            {
              required: true,
              type: 'number',
              message: '请选择推送场景',
              trigger: 'change'
            }
          ]"
        >
          <Select v-model="addForm.triggerTiming" placeholder="请选择推送场景">
            <Option
              v-for="(item, index) in pushSceneOptions"
              :key="index"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
      </Form>

      <template #footer>
        <Button @click="handleCancelAdd">取消</Button>
        <Button type="primary" :loading="addLoading" @click="handleSubmitAdd"
          >确定</Button
        >
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import {
  getPopupTestList,
  addPopupTest,
  getPopupList,
  editPopupTest,
  delPopupTest,
  getPopupTestInfo
} from '@/api/popup'
import { debounce } from 'lodash'

export default {
  name: 'NotificationTest',
  components: {
    Pages
  },
  data() {
    return {
      searchForm: {
        userId: '',
        triggerTiming: '',
        popupName: ''
      },
      tableLoading: false,
      addModalVisible: false,
      addLoading: false,
      popupSearchLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      popupOptions: [],
      // 推送场景选项
      pushSceneOptions: [
        { value: 1, label: '首页-进入APP' },
        { value: 2, label: '首页-切换分类TAB栏' },
        { value: 3, label: '播放页-进入播放页' },
        { value: 5, label: '播放页-拉起付费面板' },
        { value: 6, label: '播放页-关闭付费面板' },
        { value: 7, label: '播放页-取消订单' },
        { value: 8, label: '退出播放页' },
        { value: 13, label: '活动页' },
        { value: 12, label: '钱包页' },
        { value: 11, label: '会员页' },
        { value: 10, label: 'list页' },
        { value: 9, label: '我的页' }
      ],
      addForm: {
        id: '',
        popupId: '',
        userIds: '',
        triggerTiming: '',
        targetType: 1
      },
      columns: [
        {
          title: '弹窗备注名称',
          key: 'popupName',
          minWidth: 200
        },
        {
          title: '用户UID',
          key: 'userIds',
          minWidth: 150
        },
        {
          title: '推送场景',
          key: 'triggerTimingName',
          minWidth: 180
        },
        {
          title: '发布时间',
          key: 'createTime',
          minWidth: 180
        },
        {
          title: '操作',
          slot: 'action',
          minWidth: 150,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    async getData(current) {
      if (current) this.page.current = current
      this.tableLoading = true
      try {
        const params = {
          current: this.page.current,
          size: this.page.size,
          ...this.searchForm
        }
        const { data } = await getPopupTestList(params)
        this.tableData = data.records || []
        this.page.total = data.total || 0
      } catch (error) {
        this.$Message.error('获取列表失败')
      } finally {
        this.tableLoading = false
      }
    },
    getPushSceneLabel(value) {
      const option = this.pushSceneOptions.find((item) => item.value === value)
      return option ? option.label : '未知'
    },
    handleOpenAddModal() {
      this.addForm = {
        id: '',
        popupId: '',
        userIds: '',
        triggerTiming: '',
        targetType: 1
      }
      this.addModalVisible = true
      // 初始加载弹窗配置列表
      this.handleSearchPopup('')
    },
    async handleEdit(row) {
      try {
        const { data } = await getPopupTestInfo(row.id)
        this.addForm = {
          id: data.id,
          popupId: data.popupId,
          userIds: data.userIds,
          triggerTiming: data.triggerTiming,
          targetType: data.targetType || 1
        }

        // 预加载当前选中的弹窗选项，确保下拉框能正确显示名称
        if (data.popupName) {
          this.popupOptions = [{ id: data.popupId, popupName: data.popupName }]
        } else {
          // 如果没有名称，尝试通过 popupId 搜索或者加载默认列表
          this.handleSearchPopup('')
        }

        this.addModalVisible = true
      } catch (error) {
        this.$Message.error('获取详情失败')
      }
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '确定要删除该测试规则吗？',
        onOk: async () => {
          try {
            await delPopupTest(row.id)
            this.$Message.success('删除成功')
            this.getData(this.page.current)
          } catch (error) {
            this.$Message.error('删除失败')
          }
        }
      })
    },
    handleCancelAdd() {
      this.addModalVisible = false
      this.$refs.addFormRef.resetFields()
    },
    handleSearchPopup: debounce(async function (query) {
      if (this.popupSearchLoading) return
      this.popupSearchLoading = true
      try {
        // 使用现有的 getPopupList 接口进行模糊搜索
        const { data } = await getPopupList({
          current: 1,
          size: 100,
          popupName: query || '',
          popupStatus: 1
        })
        this.popupOptions = data.records || []
      } catch (error) {
        this.$Message.error('搜索弹窗配置失败')
      } finally {
        this.popupSearchLoading = false
      }
    }, 500),
    handleSubmitAdd() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (valid) {
          this.addLoading = true
          try {
            // 验证UID不为空
            const userIds = this.addForm.userIds.trim()

            if (!userIds) {
              this.$Message.error('请输入有效的用户UID')
              this.addLoading = false
              return
            }

            const payload = {
              popupId: this.addForm.popupId,
              userIds: userIds, // 逗号分隔的字符串，直接传给后端
              triggerTiming: this.addForm.triggerTiming,
              targetType: this.addForm.targetType
            }

            if (this.addForm.id) {
              payload.id = this.addForm.id
              await editPopupTest(payload)
              this.$Message.success('编辑成功')
              this.getData(this.page.current)
            } else {
              await addPopupTest(payload)
              this.$Message.success('添加成功')
              this.getData()
            }

            this.addModalVisible = false
          } catch (error) {
            this.$Message.error('添加失败')
          } finally {
            this.addLoading = false
          }
        }
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.header-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.table-container {
  flex: 1;
  overflow: auto;
}

.layout-card {
  display: flex;
  flex-direction: column;
  /deep/ .ivu-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
}
</style>
